import {getEventManager} from './Events';

function hookGA4() {
  window['dataLayer'] = window['dataLayer'] || [];
  function gtag() {
    window['dataLayer'].push(arguments);
  }
  getEventManager().onEvent((e) => {
    gtag('event', e.act, {
      event_category: e.cat,
      event_label: e.name,
      value: e.val,
    });
  });
}

function hookMatomo() {
  const _paq = window['_paq'] || (window['_paq'] = []);
  getEventManager().onEvent((e) => {
    if (e.act.substring(0, 5) !== 'view_')
      _paq.push(['trackEvent', e.cat ?? 'general', e.act, e.name, e.val]);
  });
}

hookGA4();
hookMatomo();
